import { color } from "@smartsheet/design-tokens-react";
import { themed } from "@smartsheet/sds-theme-internal";

export const formLabelColorTheme = themed({
    color: {
        error: color("color--text--error--weak"),
        success: {
            "lodestar-light": color("color--text--neutral--weak"),
            "ursa-light": color("color--text--success--weak"),
        },
        warn: {
            "lodestar-light": color("color--text--neutral--weak"),
            "ursa-light": color("color--text--warning--weak"),
        },
        info: color("color--text--neutral--weak"),
        waiting: color("color--text--neutral--weak"),
    },
});

export const descriptionVariantProps = themed({
    "lodestar-light": "bodyText",
    "ursa-light": "Inter--12px--400w",
});
